import TwitchIconColorized from 'root/src/client/public/icons/ic-twitch-colorized.svg';
import YouTubeIconColorized from 'root/src/client/public/icons/ic-youtube-colorized.svg';
import TikTokIconColorized from 'root/src/client/public/icons/ic-tiktok-colorized.svg';
import { Platform } from 'root/src/shared/@types/platforms';
export const darePlatformFilters = [
    { label: 'YouTube', color: 'white', icon: YouTubeIconColorized, value: Platform.YouTube, className: 'mt-[2px]' },
    { label: 'Twitch', color: 'white', icon: TwitchIconColorized, value: Platform.Twitch },
    { label: 'TikTok', color: 'white', icon: TikTokIconColorized, value: Platform.TikTok },
];
